// Module
var code = `<div class="hotkey-details-group">
    <div class="hotkey-header-group-container {{#if !.isOpen}}collapse{{/if}}" on-click="clickHeader">
        <div class="group-icon-arrow">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
            </svg>
        </div>
        <div class="group-name">{{.groupName}}</div>
    </div>

    {{#if .isOpen}}
        <div class="hotkey-body-group-container">
            {{#each groupItems: i}}
                <hotkeysEditControl item="{{groupItems[i]}}" on-ValueChanged="ValueChanged" />
            {{/each}}
        </div>
    {{/if}}
</div>`;
// Exports
export default code;